export function formatLabel(s: string) {
    return s
        .split("")
        .map((l, i) => {
            if (/[a-zA-Z]+/.test(l)) {
                if (i === 0) return l.toUpperCase();
                else if (/[A-Z]+/.test(l)) {
                    return ` ${l}`;
                } else {
                    return l;
                }
            } else return " ";
        })
        .join("");
}
